angular
	.module('App.Constant.Common', [])
	.constant 'BASE_LANGUAGE', {language: 'en', name: 'English'}
	.constant 'DISPLAY_LANGUAGE_KEY', 'display.language'
	.constant 'LANG_VARIATIONS', ['superb', 'nexgen']
	.constant 'API_VERSION', 'latest'

	# Format according to {@link https://momentjs.com/docs/#/displaying/format}
	.constant 'DATE_FORMAT', 'DD.MM.YYYY'
	.constant 'DATE_TIME_FORMAT', 'DD.MM.YYYY HH:mm'
	.constant 'DEFAULT_TIMEZONE', 'UTC'
	.constant 'DEFAULT_PRODUCT_DATA_LABEL', 'ProductData'
	.constant 'TIME_FORMAT', 'HH:mm:ss'
	.constant 'SHORT_TIME_FORMAT', 'HH:mm'
	.constant 'FILTER_TIME_FORMAT', 'HH:mm:ss'

	.constant 'SECONDS',
		MINUTE: 60
		HOUR: 3600
		DAY: 86400

	.constant 'PRODUCT_TYPE_DEFAULT', 'Products'
	.constant 'PRODUCT_TYPE_ADDON', 'AddonProduct'

	.constant 'KEY',
		ENTER: 13

	.constant 'LEGACY_INTEGRATIONS',
		[
			'diller'
			'sftp'
			'smartstore'
			'wisteria'
			'rabobank'
		]

	.constant 'PURCHASE_ORDER',
		STATUS:
			ACTIVE: 'active'
			CANCELLED: 'cancelled'
			COMPLETED: 'completed'
		DELIVERY_TYPE:
			SHOP: 'shop'
			STOCK_LOCATION: 'stock_location'

	# Last one is selected by default
	.constant 'ACCOUNTING_CATEGORIES',
		DATA: [
				{id: '04001', name: 'accounting.category.withdrawal.of.treatment.services'},
				{id: '04002', name: 'accounting.category.withdrawal.of.goods.used.for.treatment'},
				{id: '04003', name: 'accounting.category.sales.of.goods'},
				{id: '04004', name: 'accounting.category.sales.of.treatment.services'},
				{id: '04005', name: 'accounting.category.sales.of.haircut'},
				{id: '04006', name: 'accounting.category.food'},
				{id: '04007', name: 'accounting.category.beer'},
				{id: '04008', name: 'accounting.category.wine'},
				{id: '04009', name: 'accounting.category.liquor'},
				{id: '04010', name: 'accounting.category.alcopops.cider'},
				{id: '04011', name: 'accounting.category.asoft.drinks.mineral.water'},
				{id: '04012', name: 'accounting.category.other.drinks.tea.coffe'},
				{id: '04013', name: 'accounting.category.tobacco'},
				{id: '04014', name: 'accounting.category.other.goods'},
				{id: '04015', name: 'accounting.category.entrance.fee.cover.charge'},
				{id: '04016', name: 'accounting.category.free.entrace.members.etc'},
				{id: '04017', name: 'accounting.category.cloakroom.fee'},
				{id: '04018', name: 'accounting.category.free.cloakroom'},
				{id: '04019', name: 'accounting.category.accomodation.full.board'},
				{id: '04020', name: 'accounting.category.accomodation.half.board'},
				{id: '04021', name: 'accounting.category.accomodation.with.breakfast'},
				{id: '04999', name: 'accounting.category.other'}
			]
		DEFAULT:
			OTHER: '04999'
			TICKETS: '04015'

	# @see https://ui-router.github.io/ng1/docs/latest/classes/transition.rejection.html#type
	.constant 'RejectionTypes',
		SUPERSEDED: 2
		ABORTED: 3
		INVALID: 4
		IGNORED: 5
		ERROR: 6

	.constant 'MessageTypes',
		CSS_LOADED: "CSS_LOADED"
		REFRESH_SEARCH: "REFRESH_SEARCH"
		ADD_ITEM: "ADD_ITEM"
		UPDATE_ITEM: "UPDATE_ITEM"
		REMOVE_ITEM: "REMOVE_ITEM"
		REFRESH: 'REFRESH'
		LOGIN: 'LOGIN'
		LOGOUT: 'LOGOUT'
		TAB_CHANGE: 'TAB_CHANGE'
		AFTER_SAVE: 'AFTER_SAVE'
		DISPLAY_LANGUAGE: 'DISPLAY_LANGUAGE'
		BACKGROUND_PROCESS:
			START: 'START'
			WAIT: 'WAIT'
			ERROR: 'ERROR'
			COMPLETE: 'COMPLETE'
		GALLERY:
			EDIT_ORDER: 'GALLERY_EDIT_ORDER'
			EDIT: 'GALLERY_EDIT'
			DELETE: 'GALLERY_DELETE'
			AFTER_SAVE: 'GALLERY_AFTER_SAVE'
		CRUD:
			SAVE: 'SavedButtonPushed'
			DELETE: 'RemoveButtonPushed'
			ADD: "ADD_ITEM"
			UPDATE: "UPDATE_ITEM"
			REMOVE: "REMOVE_ITEM"
		PURCHASE_ORDER:
			REPORT_DATA: "PURCHASE_ORDER_REPORT_DATA"
			FILTER: "PURCHASE_ORDER_FILTER"
			ADD_ITEM: "PURCHASE_ORDER_ADD_ITEM"
			TABLE_RELOAD: "PURCHASE_ORDER_TABLE_RELOAD"

	##
	# Change default behavior of UIRouter until we can globally change defaultResolvePolicy
	# With current implementation of default `when = "LAZY"`
	# pages with search menu functionality loads up `entity-search` UI too late and there is flickering of it
	#
	# @link https://ui-router.github.io/ng1/docs/latest/interfaces/resolve.resolvepolicy.html
	# @see SMB-2338
	# @see angular-ui-router.js@2350 (`var defaultResolvePolicy`)
	##
	.constant 'DEFAULT_RESOLVE_POLICY',
		when: 'EAGER'
		async: 'WAIT'

	.constant 'PROMOTION_CONSTANTS',
		noCategory: "Uncategorized"
		meta:
			percentage_off: "PERCENTAGE_OFF"
			amount_off: "AMOUNT_OFF"
			fixed_price: "FIXED_PRICE"
			fixed_product_price: "FIXED_PRODUCT_PRICE"
			free_quantity: "FREE_QUANTITY"
		subtype:
			sale: "SALE"
			item: "ITEM"
			selected_items: "SELECTED_ITEMS"
			benefit: "BENEFIT"
			cheapest: "CHEAPEST"
			most_expensive: "MOST_EXPENSIVE"
			qualification_items: "QUALIFICATION_ITEMS"

	.constant 'SEARCH_FILTER_TYPE',
		date: 'date'
		text: 'text'
		select: 'select'
		boolean: 'boolean'
		entityType: 'entity-type'

	.constant 'SEARCH_CONFIGURATION',
		customer:
			id: {property: 'id', label: 'general.customer.id'}
			name: {property: 'name', label: 'ecommerce.shipping.customer.name'}
			email: {property: 'email', label: 'ecommerce.shipping.customer.email'}
			mobile_phone: {property: 'mobilephone', label: 'add.customer.placeholder.mobile.phone'}
			work_phone: {property: 'workphone', label: 'add.customer.placeholder.work.phone'}
			company_cvr: {property: 'company_cvr', label: 'customer.attribute.company_cvr'}

		# PromotionSearchController will add additional labels
		promotion:
			id: {property: 'id', label: 'general.id'}
			name: {property: 'name', label: 'general.name'}

		products: [
			{
				title: 'general.products'
				filters:
					type:
						type: 'entity-type'
						options:
							entity_type: 'BACKEND_PRODUCT_ENTITY_TYPE'
							label_prefix: 'general.product.type'
							except: ['ShippingProduct', 'TicketProducts', 'VoucherProduct', 'GiftcardProduct']
					id: {property: 'id', label: 'general.id'}
					name: {property: 'name', label: 'general.name', options: {translatable: {property: 'name'}}}
					sku:
						property: 'sku'
						label: 'general.sku'
						options:
							additional_conditions: [{property: 'product_skus>value'}]
					category:
						property: 'product_categories>id'
						label: 'general.category'
						type: 'select'
						options:
							repository: 'ProductCategoryRepository'
							with: ['product_categories']
					supplier_id:
						property: 'supplier_id'
						label: 'general.supplier'
						type: 'select'
						options:
							repository: 'SuppliersRepository'
					is_active: {type: 'boolean', property: 'active', label: 'general.active'}
			}
			{
				title: 'wbo.product.variants'
				filters:
					variant_id: {property: 'product_variants>id', label: 'general.id'}
					variant_name:
						property: 'product_variants>product_variant_name'
						label: 'general.name'
						options:
							translatable:
								relation: 'product_variants>translations'
								property: 'product_variant_name'
							with: ['product_variants']
					variant_sku:
						property: 'product_variants>sku'
						label: 'general.sku'
						options:
							additional_conditions: [{property: 'product_variants_product_variant_skus>value'}]
							with: ['product_variants', 'product_variants>product_variant_skus']
					supplier_id:
						property: 'product_variants>supplier_id'
						label: 'general.supplier'
						type: 'select'
						options:
							repository: 'SuppliersRepository'
			}
		]

		order: [
			{
				filters:
					timestamp: {property: 'timestamp', label: 'general.date', type: 'date'}
					id: {property: 'id', label: 'general.id'}
					status: {property: 'status', label: 'general.status', type: 'select'}
					email: {property: 'email', label: 'general.email'}
					shop_id:
						property: 'shop_id'
						label: 'general.shop.name'
						type: 'select'
						options:
							repository: 'ShopRepository'
					register_id:
						property: 'register_id'
						label: 'general.register.name'
						type: 'select'
						options:
							repository: 'RegisterRepository'
					user_id:
						property: 'user_id'
						label: 'general.username'
						type: 'select'
						options:
							repository: 'UserRepository'
							text_property: 'full_name'
					customer_id:
						property: 'customer_id'
						label: 'general.customer'
						type: 'select'
						options:
							repository: 'CustomerRepository'
					sequence_number: {property: 'sequence_number', label: 'general.order.sequence.id'}
					device_id: {property: 'device_id', label: 'general.register.device.id'}
			}
			{
				filters:
					is_preorder: {property: 'is_preorder', label: 'general.preorder', type: 'boolean'}
			}
		]

		invoice: [
			{
				filters:
					timestamp: {property: 'issue_date', label: 'general.date', type: 'date'}
					id: {property: 'id', label: 'general.id'}
					invoice_number: {property: 'invoice_number', label: 'general.invoice.invoice_number'}
					status:
						property: 'status'
						label: 'general.invoice.status'
						type: 'select'
					customer_id:
						property: 'customer_id'
						label: 'general.customer'
						type: 'select'
						options:
							repository: 'CustomerRepository'
			}
		]

		invoiced_order: [
			{
				filters:
					timestamp: {property: 'timestamp', label: 'general.date', type: 'date'}
					email: {property: 'email', label: 'general.email'}
					status:
						property: 'transactions>invoice_status'
						label: 'general.order.invoice.status'
						type: 'select'
					invoice_id:
						property: 'transactions>invoice_id'
						label: 'general.invoice.invoice_number'
						type: 'select'
						options:
							repository: 'InvoiceRepository'
							text_property: 'invoice_number'
					customer_id:
						property: 'customer_id'
						label: 'general.customer'
						type: 'select'
						options:
							repository: 'CustomerRepository'
					shop_id:
						property: 'shop_id'
						label: 'general.shop.name'
						type: 'select'
						options:
							repository: 'ShopRepository'
					register_id:
						property: 'register_id'
						label: 'general.register.name'
						type: 'select'
						options:
							repository: 'RegisterRepository'
			}
		]

		purchase_order:
			id: {property: 'id', label: 'general.id'}
			name: {property: 'name', label: 'general.name'}
			email: {property: 'email', label: 'general.email'}
			status: {property: 'status', label: 'general.status', type: 'select'}
			external_id: {property: 'external_id', label: 'external.attributes.external_id'}
			expected_delivery:
				property: 'expected_delivery_time'
				label: 'general.purchase_order.expected_delivery_time'
				type: 'date'
				options:
					timePicker: false
			supplier:
				property: 'supplier_id'
				label: 'general.supplier'
				type: 'select'
				options:
					repository: 'SuppliersRepository'

		stock_list:
			category_name: {property: 'product_categories>name', label: 'general.categories'}
			product_id:
				property: 'products>id'
				label: 'general.product'
				type: 'select'
				options:
					repository: 'ProductRepository'
			product_sku:
				property: 'products>sku'
				label: 'general.sku'
				options:
					additional_conditions: [{property: 'product_variants>sku'}]
			supplier_id:
				property: 'products>supplier_id'
				label: 'general.supplier'
				type: 'select'
				options:
					repository: 'SuppliersRepository'
					additional_conditions: [{property: 'product_variants>supplier_id'}]

		stock_event:
			timestamp: {property: 'timestamp', label: 'general.date', type: 'date'}
			reference_id: {property: 'reference_id', label: 'wbo.stock.reference'}
			reason_code_id:
				property: 'reason_code_id'
				label: 'reason.code'
				type: 'select'
				options:
					group_property: 'label_text'
			sku:
				property: 'stock_event_lines_product>sku'
				label: 'general.sku'
				options:
					with: ['stock_event_lines', 'stock_event_lines>product', 'stock_event_lines>product_variant']
					additional_conditions: [{property: 'stock_event_lines_product_variant>sku'}]
			product_id:
				property: 'stock_event_lines>product_id'
				label: 'general.product'
				type: 'select'
				options:
					with: ['stock_event_lines']
					alt_label: 'general.product.id'

		inventory_count:
			timestamp: {property: 'timestamp', label: 'general.date', type: 'date'}
			shop_id: {property: 'shop_id', label: 'general.shop', type: 'select'}
			status: {property: 'status', label: 'general.status', type: 'select'}

		ticket:
			id: {property: 'id', label: 'general.id'}
			email: {property: 'email', label: 'general.email'}
			order_id: {property: 'order_id', label: 'general.order.id'}
			type:
				property: 'ticket_type_id'
				label: 'general.ticket_type'
				type: 'select'
				options:
					repository: 'TicketTypeRepository'
			event:
				property: 'ticket_event_id'
				label: 'general.ticket_event'
				type: 'select'
				options:
					repository: 'TicketEventRepository'

		ticket_type:
			id: {property: 'id', label: 'general.id'}
			name:
				property: 'product>name'
				label: 'general.name'
				options:
					with: ['product']
					translatable:
						relation: 'product>translations'
						property: 'name'
			event:
				property: 'ticket_event_id'
				label: 'general.ticket_event'
				type: 'select'
				options:
					repository: 'TicketEventRepository'

		voucher:
			id: {property: 'id', label: 'general.id'}
			email: {property: 'email', label: 'general.email.address'}
			voucher_type:
				property: 'voucher_type_id'
				label: 'wbo.voucher.type'
				type: 'select'
				options:
					repository: 'VoucherTypeRepository'

		register:
			id: {property: 'id', label: 'general.id'}
			name: {property: 'name', label: 'general.name'}
			type:
				type: 'entity-type'
				options:
					entity_type: 'BACKEND_REGISTER_ENTITY_TYPE'
					label_prefix: 'general.register.type'
					except: ['Registers']

		user:
			id: {property: 'id', label: 'general.id'}
			name: {property: 'full_name', label: 'general.full.name'}
			email: {property: 'email', label: 'general.email'}
			user_number: {property: 'user_number', label: 'general.user.number'}
			role:
				property: 'role_id'
				label: 'general.role'
				type: 'select'
				options:
					repository: 'UserRoleRepository'

		journal_event:
			timestamp: {property: 'timestamp', label: 'general.date', type: 'date'}
			type:
				type: 'entity-type'
				options:
					entity_type: 'BACKEND_JOURNAL_EVENT_ENTITY_TYPE'
					label_prefix: 'general.journal_event.type'
			shop:
				property: 'shop_id'
				label: 'general.shop'
				type: 'select'
				options:
					repository: 'ShopRepository'
			register:
				property: 'register_id'
				label: 'general.register'
				type: 'select'
				options:
					repository: 'RegisterRepository'
			user:
				property: 'user_id'
				label: 'general.user'
				type: 'select'
				options:
					repository: 'UserRepository'
					text_property: 'full_name'

		day_tally:
			start_time: {property: 'start_time', label: 'wbo.eod.start.date', type: 'date'}
			end_time: {property: 'end_time', label: 'wbo.eod.end.date', type: 'date'}
			comment: {property: 'comment', label: 'general.comment'}
			bag_id: {property: 'bag_id', label: 'general.bag_id'}
			shop_id:
				property: 'shop_id'
				label: 'general.shop.name'
				type: 'select'
				options:
					repository: 'ShopRepository'
			register_id:
				property: 'register_id'
				label: 'general.register.name'
				type: 'select'
				options:
					repository: 'RegisterRepository'
				sequence_number: {property: 'sequence_number', label: 'general.order.sequence.id'}

		integration_log:
			integration_id:
				property: 'integration_id'
				label: 'general.integration'
				type: 'select'
				options:
					repository: 'IntegrationRepository'
					required: true
			entity: {property: 'entity', label: 'general.entity', type: 'select'}
			owner_id: {property: 'owner_id', label: 'general.id'}
			timestamp: {property: 'update_time', label: 'general.timestamp', type: 'date'}
			status: {property: 'status', label: 'general.status', type: 'select'}

		bulk_data_log:
			update_time: {property: 'update_time', label: 'general.bulk_data_log.update_time', type: 'date'}
			create_time: {property: 'create_time', label: 'general.bulk_data_log.create_time', type: 'date'}
			entity: {property: 'type', label: 'general.entity'}
			status: {property: 'status', label: 'general.status', type: 'select'}
			action: {property: 'action', label: 'general.action', type: 'select'}
